import {
  DOWNLOAD_BOOKING_REPORT_FAILURE,
  DOWNLOAD_BOOKING_REPORT_REQUEST,
  DOWNLOAD_BOOKING_REPORT_RESET,
  DOWNLOAD_BOOKING_REPORT_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const downloadBookingReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_BOOKING_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case DOWNLOAD_BOOKING_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case DOWNLOAD_BOOKING_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case DOWNLOAD_BOOKING_REPORT_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default downloadBookingReportReducer
